const Textarea = ({
  label,
  errorMessage,
  className = "",
  onValueChange,
  ...props
}) => {
  const handleChange = (e) => {
    props.onChange && props.onChange(e);
    onValueChange && onValueChange(e.target.value);
  };

  return (
    <div className={`custom-input ct-textarea ${className}`}>
      {label ? <label htmlFor={props.id}>{label}</label> : null}
      <textarea className="w-100" {...props} onChange={handleChange} />
      <div
        className={`d-flex align-items-center px-2 position-relative ${
          props.maxLength && !errorMessage
            ? "justify-content-end"
            : "justify-content-between"
        }`}
        style={{ top: -4 }}
      >
        {errorMessage && <p className="errorMessage">{errorMessage}</p>}

        {props.maxLength && (
          <span className="text-end max-input">
            {props.value.length}/{props.maxLength}
          </span>
        )}
      </div>
    </div>
  );
};

export default Textarea;
